/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useState } from 'react'
import { MyContext } from '../Context/MyProvider';
import { showToast } from '../showTost';
import secureLocalStorage from 'react-secure-storage';
const Stripe = ({ Amount }) => {

    const { BaseUrl, setPaymentRes, setPaymentLoading } = useContext(MyContext);

    const [cardNumber, setCardnumber] = useState();
    const [expiry, setExpiry] = useState('');
    const [cvc, setCvc] = useState();
    const [loading, setLoading] = useState(false);

    const Currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        setPaymentLoading(false);
        secureLocalStorage.setItem("Amount", Amount);
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (loading) {
            showToast({ title: "Payment in Process !!", id: "info" });
            return;
        }

        if (!cardNumber && !expiry && !cvc) {
            showToast({ title: "Enter Payment Details !!", id: "error" });
            return;
        }

        setLoading(true);

        const number = cardNumber.replace(/\s+/g, '');
        const month = expiry.split("/")[0];
        const year = expiry.split("/")[1];

        const currentYear = new Date().getFullYear();
        const currentYearLastTwoDigits = currentYear.toString().slice(-2);

        const loginuser = secureLocalStorage.getItem("Logindata");

        if (loginuser) {
            const UserDetails = JSON.parse(loginuser);

            axios.post(`${BaseUrl}/react_stripe/token.php`,
                {
                    "card_number": number,
                    "exp_month": month,
                    "exp_year": `${currentYearLastTwoDigits}${year.slice(2)}`,
                    "cvc": cvc,
                    "custName": UserDetails.name,
                    "custEmail": `${UserDetails.name}@gmail.com`,
                    "amount": Amount
                }
            )
                .then((res) => {
                    if (res.data.Result === "true") {
                        setPaymentRes("PaymentDone");
                        sessionStorage.setItem("transactionid", res.data.Transaction_id);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("react_stripe/token.php", error);
                });
        }
    };

    const handleCardNumberChange = (e) => {
        let value = e.target.value;
        const cleanedValue = value.replace(/\D/g, '');
        const formattedValue = cleanedValue.replace(/(\d{4})(?=\d)/g, '$1 ');
        setCardnumber(formattedValue);
    };

    const handleExpiryChange = (e) => {
        const value = e.target.value;
        const cleanedValue = value.replace(/\D/g, '');
        const formattedValue = cleanedValue.replace(/(\d{2})(?=\d)/g, '$1/');
        setExpiry(formattedValue);
    };


    return (
        <form onSubmit={handleSubmit} className="DemoWrapper w-[100%] text-start">
            <label className=''>
                <span className='text-[18px] font-[500]'>Card number</span> <br />
                <input
                    type="text"
                    placeholder="1234 1234 1234 1234"
                    value={cardNumber}
                    onChange={handleCardNumberChange}
                    maxLength="19"
                    className='border-[2px] w-[100%] focus-within:border-[--bgcolor] outline-none py-[3px] px-[5px] rounded-[5px] mt-[5px]'
                />
            </label>
            <div className="flex justify-between items-center mt-[10px]">
                <label className='w-[40%] text-start'>
                    <span className='text-[18px] font-[500]' >Expiration date</span>
                    <input
                        type="text"
                        placeholder="MM/YY"
                        value={expiry}
                        onChange={handleExpiryChange}
                        maxLength="5"
                        className='border-[2px] w-[100%] outline-none py-[3px] px-[5px] rounded-[5px] mt-[5px] focus-within:border-[--bgcolor]'
                    />
                </label>
                <label className='w-[40%] text-start'>
                    <span className='text-[18px] font-[500] ' >CVC</span>
                    <input type='number' onChange={(e) => setCvc(e.target.value)} placeholder='CVC' className='border-[2px] focus-within:border-[--bgcolor] w-[100%] outline-none py-[3px] px-[5px] rounded-[5px] mt-[5px]' />
                </label>
            </div>
            <button type="submit" className='w-full text-white rounded-[5px] mt-[10px] font-bold text-[17px] bg-[--bgcolor] py-[10px] hover:shadow-[0,5px,8px,rgba(2,6,12,.2)]'>
                {loading ? <span className="btn_loader mx-auto"></span> : `Pay ${Currency + Amount}`}
            </button>
        </form>
    )
}

export default Stripe;
/* jshint ignore:end */